export default "__VITE_ASSET__DN7exdln__"